import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import styles from "./navbar.module.scss";

export const Navbar = () => {
  return (
    <div
    className={styles.navbarContainer}>
      <Tabs
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        className={styles['tabs']}
        style={{  fontFamily: 'Roboto'}}
        value={0}
      >
        <Tab href="#home" label="Home" className={styles['tab']} />
        <Tab href="#rsvp"  label="RSVP" className={styles['tab']} />
        <Tab href="#schedule" 
          label="Schedule"
          className={styles.tab}
        />
      
      </Tabs>
    </div>
  );
};